module.exports = __webpack_public_path__ + "img/quizz-step-6-2.92a0c6b2.jpg";